/**
 * Global JS for BulkRubberBands V2 theme.
 * Sticky header scroll detection, mobile menu toggle.
 */
(function () {
  'use strict';

  /* --- Sticky Header Shadow on Scroll --- */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var scrollThreshold = 50;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > scrollThreshold) {
            header.classList.add('site-header--scrolled');
          } else {
            header.classList.remove('site-header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  var mobileMenu = document.getElementById('mobile-menu');
  if (mobileMenu) {
    // Open
    document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenu.classList.add('mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Focus first link
        var firstLink = mobileMenu.querySelector('.mobile-menu__link');
        if (firstLink) setTimeout(function () { firstLink.focus(); }, 100);
      });
    });

    // Close
    document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenu.classList.remove('mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('mobile-menu--open')) {
        mobileMenu.classList.remove('mobile-menu--open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  }

  /* --- Dropdown Keyboard Accessibility --- */
  document.querySelectorAll('[data-dropdown]').forEach(function (dropdown) {
    var toggle = dropdown.querySelector('.site-nav__link');
    var menu = dropdown.querySelector('.site-nav__dropdown-menu');
    if (!toggle || !menu) return;

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !expanded);
        if (!expanded) {
          var firstChild = menu.querySelector('a');
          if (firstChild) firstChild.focus();
        }
      }
    });
  });
})();
